<template>
  <div>
    <h2 class="border-none">Do you have any other interests or hobbies?</h2>
    <div>
      <div class="spacer-b-2 lead-text">Add your hobbies to get more opportunities you'll enjoy</div>
      <div class="flex flex-row flex-wrap gray-500 w-2/3 justify-between">
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-microphone"></i></div> Brand Ambassadorships</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-phone"></i></div> Video-shoutouts</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-comments"></i></div> Social Media Campaigns</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-camera"></i></div> Meet & Greets</div>
      </div>
    </div>
    <div class="spacer-t-5">
      <div class="flex flex-wrap" v-if="suggestedPersonalInterests && suggestedPersonalInterests.length">
        <strong>Suggestions</strong>
        <div class="underline spacer-x-1" v-for="suggestion in suggestedPersonalInterests" :key="suggestion.id">
          <span class="cursor-pointer" @click="() => { $emit('selected', suggestion) }">{{ suggestion.name }}</span>
        </div>
      </div>
      <search-picker
        :full-width="true"
        :with-icon="true"
        :with-popper="true"
        :get-data="getPersonalInterests"
        @selected="(option) => { $emit('selected', option) }"
        :current="personalInterests"
        placeholder="Add topic"
        class="margin-y-1">
        <template v-slot:list-item-content="{ option }">
          <div
            v-if="option.group"
            class="search-picker__subtext">
            <span>{{ option.group }}</span>
          </div>
        </template>
      </search-picker>
    </div>
    <div class="w-full flex flex-wrap">
      <div
        v-for="(interest, index) in personalInterests"
        :key="interest.id"
        class="category category--selected">
        {{ interest.name }}
        <i class="fa fa-times" @click="$emit('unselect', interest.id, index, interest.name)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import TagPicker from '../misc/TagPicker'
import SearchPicker from '../misc/SearchPicker'
import { http } from 'utils'
export default {
  components: { TagPicker, SearchPicker },
  props: {
    personalInterests: {
      required: true
    },
    suggestedPersonalInterests: {
      required: true
    }
  },

  methods: {
    async getPersonalInterests (params) {
      const response = await http.get('personal-interests', { params })
      return response.data.data
    }
  }
}
</script>
